(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('tokens', {
            parent: 'app',
            url: '/admin/tokens',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/token/token.html',
                    controller: 'TokenController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
